var map = {
	"./accept-invitation-icon.svg": "./src/assets/icons/accept-invitation-icon.svg",
	"./account-enable-icon.svg": "./src/assets/icons/account-enable-icon.svg",
	"./account-icon.svg": "./src/assets/icons/account-icon.svg",
	"./add-administrator-icon.svg": "./src/assets/icons/add-administrator-icon.svg",
	"./add-agent-icon.svg": "./src/assets/icons/add-agent-icon.svg",
	"./add-agent-name.svg": "./src/assets/icons/add-agent-name.svg",
	"./add-agents-icon.svg": "./src/assets/icons/add-agents-icon.svg",
	"./add-asset.svg": "./src/assets/icons/add-asset.svg",
	"./add-client-icon.svg": "./src/assets/icons/add-client-icon.svg",
	"./add-date.svg": "./src/assets/icons/add-date.svg",
	"./add-filled-icon.svg": "./src/assets/icons/add-filled-icon.svg",
	"./add-form-icon.svg": "./src/assets/icons/add-form-icon.svg",
	"./add-icon.svg": "./src/assets/icons/add-icon.svg",
	"./add-id-task.svg": "./src/assets/icons/add-id-task.svg",
	"./add-inventory.svg": "./src/assets/icons/add-inventory.svg",
	"./add-isochrone-icon.svg": "./src/assets/icons/add-isochrone-icon.svg",
	"./add-manager-icon.svg": "./src/assets/icons/add-manager-icon.svg",
	"./add-notification-icon.svg": "./src/assets/icons/add-notification-icon.svg",
	"./add-permission-icon.svg": "./src/assets/icons/add-permission-icon.svg",
	"./add-role-icon.svg": "./src/assets/icons/add-role-icon.svg",
	"./add-task-type-icon.svg": "./src/assets/icons/add-task-type-icon.svg",
	"./add-user-icon.svg": "./src/assets/icons/add-user-icon.svg",
	"./add-user-red-icon.svg": "./src/assets/icons/add-user-red-icon.svg",
	"./add-user-top-icon.svg": "./src/assets/icons/add-user-top-icon.svg",
	"./admin-icon.svg": "./src/assets/icons/admin-icon.svg",
	"./advanced-analytics-image.svg": "./src/assets/icons/advanced-analytics-image.svg",
	"./agent-notification.svg": "./src/assets/icons/agent-notification.svg",
	"./agents-icon.svg": "./src/assets/icons/agents-icon.svg",
	"./alert-icon.svg": "./src/assets/icons/alert-icon.svg",
	"./analytics-icon.svg": "./src/assets/icons/analytics-icon.svg",
	"./api-user-profile.svg": "./src/assets/icons/api-user-profile.svg",
	"./api-user.svg": "./src/assets/icons/api-user.svg",
	"./arrow-left-icon.svg": "./src/assets/icons/arrow-left-icon.svg",
	"./arrow-modify.svg": "./src/assets/icons/arrow-modify.svg",
	"./arrow-right-icon.svg": "./src/assets/icons/arrow-right-icon.svg",
	"./assetManagement-icon.svg": "./src/assets/icons/assetManagement-icon.svg",
	"./assets-icon.svg": "./src/assets/icons/assets-icon.svg",
	"./assets-light-grey-icon.svg": "./src/assets/icons/assets-light-grey-icon.svg",
	"./assetsm.svg": "./src/assets/icons/assetsm.svg",
	"./assign-resources-icon.svg": "./src/assets/icons/assign-resources-icon.svg",
	"./assing-group-task-icon.svg": "./src/assets/icons/assing-group-task-icon.svg",
	"./assisted-form.svg": "./src/assets/icons/assisted-form.svg",
	"./attach-icon.svg": "./src/assets/icons/attach-icon.svg",
	"./autoassign-add-icon.svg": "./src/assets/icons/autoassign-add-icon.svg",
	"./autoassign-icon.svg": "./src/assets/icons/autoassign-icon.svg",
	"./automation-icon.svg": "./src/assets/icons/automation-icon.svg",
	"./automation.svg": "./src/assets/icons/automation.svg",
	"./bad-icon-png.png": "./src/assets/icons/bad-icon-png.png",
	"./bar-graph-icon-black.svg": "./src/assets/icons/bar-graph-icon-black.svg",
	"./bar-graph-icon.svg": "./src/assets/icons/bar-graph-icon.svg",
	"./big-admin-icon.svg": "./src/assets/icons/big-admin-icon.svg",
	"./big-agent-icon.svg": "./src/assets/icons/big-agent-icon.svg",
	"./big-asset-icon.svg": "./src/assets/icons/big-asset-icon.svg",
	"./big-branch-icon.svg": "./src/assets/icons/big-branch-icon.svg",
	"./big-client-icon.svg": "./src/assets/icons/big-client-icon.svg",
	"./big-company-icon.svg": "./src/assets/icons/big-company-icon.svg",
	"./big-form-icon.svg": "./src/assets/icons/big-form-icon.svg",
	"./big-group-icon.svg": "./src/assets/icons/big-group-icon.svg",
	"./big-inventory-icon.svg": "./src/assets/icons/big-inventory-icon.svg",
	"./big-manager-icon.svg": "./src/assets/icons/big-manager-icon.svg",
	"./big-partner-icon.svg": "./src/assets/icons/big-partner-icon.svg",
	"./big-route-icon.svg": "./src/assets/icons/big-route-icon.svg",
	"./big-task-icon.svg": "./src/assets/icons/big-task-icon.svg",
	"./big-teams-icon.svg": "./src/assets/icons/big-teams-icon.svg",
	"./black-agent-icon.svg": "./src/assets/icons/black-agent-icon.svg",
	"./block-user-icon.svg": "./src/assets/icons/block-user-icon.svg",
	"./branch-icon.svg": "./src/assets/icons/branch-icon.svg",
	"./calendar-icon.svg": "./src/assets/icons/calendar-icon.svg",
	"./calendar-time-icon.svg": "./src/assets/icons/calendar-time-icon.svg",
	"./camera-icon.svg": "./src/assets/icons/camera-icon.svg",
	"./cancel-route-icon.svg": "./src/assets/icons/cancel-route-icon.svg",
	"./cancel-task-icon.svg": "./src/assets/icons/cancel-task-icon.svg",
	"./cancel.svg": "./src/assets/icons/cancel.svg",
	"./change-type-graph-black.svg": "./src/assets/icons/change-type-graph-black.svg",
	"./change-type-graph.svg": "./src/assets/icons/change-type-graph.svg",
	"./changeOrder.png": "./src/assets/icons/changeOrder.png",
	"./chatbot-icon.svg": "./src/assets/icons/chatbot-icon.svg",
	"./check-circle-outline.svg": "./src/assets/icons/check-circle-outline.svg",
	"./checkbox-open-icon.svg": "./src/assets/icons/checkbox-open-icon.svg",
	"./chevron-right.svg": "./src/assets/icons/chevron-right.svg",
	"./clap-icon.svg": "./src/assets/icons/clap-icon.svg",
	"./client-icon.svg": "./src/assets/icons/client-icon.svg",
	"./clock-icon.svg": "./src/assets/icons/clock-icon.svg",
	"./closed-accordion-icon.svg": "./src/assets/icons/closed-accordion-icon.svg",
	"./columns-icon.svg": "./src/assets/icons/columns-icon.svg",
	"./comment-icon.svg": "./src/assets/icons/comment-icon.svg",
	"./company-icon.svg": "./src/assets/icons/company-icon.svg",
	"./control-icon.svg": "./src/assets/icons/control-icon.svg",
	"./create-group-tasks.svg": "./src/assets/icons/create-group-tasks.svg",
	"./create-task.svg": "./src/assets/icons/create-task.svg",
	"./createAA-icon.svg": "./src/assets/icons/createAA-icon.svg",
	"./custom-task-icon.svg": "./src/assets/icons/custom-task-icon.svg",
	"./cycle-icon.svg": "./src/assets/icons/cycle-icon.svg",
	"./danger-alert-icon.svg": "./src/assets/icons/danger-alert-icon.svg",
	"./danger-icon.svg": "./src/assets/icons/danger-icon.svg",
	"./dark-cancel-icon.svg": "./src/assets/icons/dark-cancel-icon.svg",
	"./dashboard-icon.svg": "./src/assets/icons/dashboard-icon.svg",
	"./default-profile-icon.svg": "./src/assets/icons/default-profile-icon.svg",
	"./delete-group-task-icon.svg": "./src/assets/icons/delete-group-task-icon.svg",
	"./delete-icon.svg": "./src/assets/icons/delete-icon.svg",
	"./detalle-task-icon.svg": "./src/assets/icons/detalle-task-icon.svg",
	"./disable-branch-icon.svg": "./src/assets/icons/disable-branch-icon.svg",
	"./disable-team-icon.svg": "./src/assets/icons/disable-team-icon.svg",
	"./disable-user-icon.svg": "./src/assets/icons/disable-user-icon.svg",
	"./disabled-icon.svg": "./src/assets/icons/disabled-icon.svg",
	"./docx-file-icon.svg": "./src/assets/icons/docx-file-icon.svg",
	"./domain-icon.svg": "./src/assets/icons/domain-icon.svg",
	"./donwload-fom-icon.svg": "./src/assets/icons/donwload-fom-icon.svg",
	"./down-arrow-icon.svg": "./src/assets/icons/down-arrow-icon.svg",
	"./download-export-task.svg": "./src/assets/icons/download-export-task.svg",
	"./download-form-images.svg": "./src/assets/icons/download-form-images.svg",
	"./drop-rigth-icon.svg": "./src/assets/icons/drop-rigth-icon.svg",
	"./drop-rigth.svg": "./src/assets/icons/drop-rigth.svg",
	"./dropdown-close-small.svg": "./src/assets/icons/dropdown-close-small.svg",
	"./dropdown-icon.svg": "./src/assets/icons/dropdown-icon.svg",
	"./dropdown-open-small.svg": "./src/assets/icons/dropdown-open-small.svg",
	"./dropdown.svg": "./src/assets/icons/dropdown.svg",
	"./dynamicAllocation-icon.svg": "./src/assets/icons/dynamicAllocation-icon.svg",
	"./edit-group-task-icon.svg": "./src/assets/icons/edit-group-task-icon.svg",
	"./edit-group-task-popup-icon.svg": "./src/assets/icons/edit-group-task-popup-icon.svg",
	"./edit-group-tasks-icon.svg": "./src/assets/icons/edit-group-tasks-icon.svg",
	"./edit-icon.svg": "./src/assets/icons/edit-icon.svg",
	"./edit-red-icon.svg": "./src/assets/icons/edit-red-icon.svg",
	"./edit.svg": "./src/assets/icons/edit.svg",
	"./empresarial-theme-icon.svg": "./src/assets/icons/empresarial-theme-icon.svg",
	"./empty-logo-icon.png": "./src/assets/icons/empty-logo-icon.png",
	"./empty-logo-icon.svg": "./src/assets/icons/empty-logo-icon.svg",
	"./examplemap-icon.PNG": "./src/assets/icons/examplemap-icon.PNG",
	"./excel-logo-icon.png": "./src/assets/icons/excel-logo-icon.png",
	"./expenses.png": "./src/assets/icons/expenses.png",
	"./export-icon.svg": "./src/assets/icons/export-icon.svg",
	"./fielder-logo-404.svg": "./src/assets/icons/fielder-logo-404.svg",
	"./fielder-logo.svg": "./src/assets/icons/fielder-logo.svg",
	"./filter-icon.svg": "./src/assets/icons/filter-icon.svg",
	"./form-finished-icon.svg": "./src/assets/icons/form-finished-icon.svg",
	"./form-green-icon.svg": "./src/assets/icons/form-green-icon.svg",
	"./form-icon.svg": "./src/assets/icons/form-icon.svg",
	"./form-strong-icon.svg": "./src/assets/icons/form-strong-icon.svg",
	"./form-yellow-icon.svg": "./src/assets/icons/form-yellow-icon.svg",
	"./forms.svg": "./src/assets/icons/forms.svg",
	"./gallery-icon.svg": "./src/assets/icons/gallery-icon.svg",
	"./good-icon-png.png": "./src/assets/icons/good-icon-png.png",
	"./grey-star-icon.png": "./src/assets/icons/grey-star-icon.png",
	"./group-download-images.svg": "./src/assets/icons/group-download-images.svg",
	"./group-notification.svg": "./src/assets/icons/group-notification.svg",
	"./group-task-table-icon.svg": "./src/assets/icons/group-task-table-icon.svg",
	"./happy-sad-icon.svg": "./src/assets/icons/happy-sad-icon.svg",
	"./help-icon.svg": "./src/assets/icons/help-icon.svg",
	"./help/icon1.svg": "./src/assets/icons/help/icon1.svg",
	"./help/icon10.svg": "./src/assets/icons/help/icon10.svg",
	"./help/icon11.svg": "./src/assets/icons/help/icon11.svg",
	"./help/icon12.svg": "./src/assets/icons/help/icon12.svg",
	"./help/icon13.svg": "./src/assets/icons/help/icon13.svg",
	"./help/icon14.svg": "./src/assets/icons/help/icon14.svg",
	"./help/icon15.svg": "./src/assets/icons/help/icon15.svg",
	"./help/icon16.svg": "./src/assets/icons/help/icon16.svg",
	"./help/icon17.svg": "./src/assets/icons/help/icon17.svg",
	"./help/icon18.svg": "./src/assets/icons/help/icon18.svg",
	"./help/icon19.svg": "./src/assets/icons/help/icon19.svg",
	"./help/icon2.svg": "./src/assets/icons/help/icon2.svg",
	"./help/icon20.svg": "./src/assets/icons/help/icon20.svg",
	"./help/icon21.svg": "./src/assets/icons/help/icon21.svg",
	"./help/icon22.svg": "./src/assets/icons/help/icon22.svg",
	"./help/icon23.svg": "./src/assets/icons/help/icon23.svg",
	"./help/icon24.svg": "./src/assets/icons/help/icon24.svg",
	"./help/icon25.svg": "./src/assets/icons/help/icon25.svg",
	"./help/icon26.svg": "./src/assets/icons/help/icon26.svg",
	"./help/icon27.svg": "./src/assets/icons/help/icon27.svg",
	"./help/icon28.svg": "./src/assets/icons/help/icon28.svg",
	"./help/icon29.svg": "./src/assets/icons/help/icon29.svg",
	"./help/icon3.svg": "./src/assets/icons/help/icon3.svg",
	"./help/icon30.svg": "./src/assets/icons/help/icon30.svg",
	"./help/icon31.svg": "./src/assets/icons/help/icon31.svg",
	"./help/icon32.svg": "./src/assets/icons/help/icon32.svg",
	"./help/icon33.svg": "./src/assets/icons/help/icon33.svg",
	"./help/icon34.svg": "./src/assets/icons/help/icon34.svg",
	"./help/icon35.svg": "./src/assets/icons/help/icon35.svg",
	"./help/icon36.svg": "./src/assets/icons/help/icon36.svg",
	"./help/icon37.svg": "./src/assets/icons/help/icon37.svg",
	"./help/icon38.svg": "./src/assets/icons/help/icon38.svg",
	"./help/icon39.svg": "./src/assets/icons/help/icon39.svg",
	"./help/icon4.svg": "./src/assets/icons/help/icon4.svg",
	"./help/icon40.svg": "./src/assets/icons/help/icon40.svg",
	"./help/icon41.svg": "./src/assets/icons/help/icon41.svg",
	"./help/icon42.svg": "./src/assets/icons/help/icon42.svg",
	"./help/icon43.svg": "./src/assets/icons/help/icon43.svg",
	"./help/icon44.svg": "./src/assets/icons/help/icon44.svg",
	"./help/icon45.svg": "./src/assets/icons/help/icon45.svg",
	"./help/icon46.svg": "./src/assets/icons/help/icon46.svg",
	"./help/icon47.svg": "./src/assets/icons/help/icon47.svg",
	"./help/icon5.svg": "./src/assets/icons/help/icon5.svg",
	"./help/icon6.svg": "./src/assets/icons/help/icon6.svg",
	"./help/icon7.svg": "./src/assets/icons/help/icon7.svg",
	"./help/icon8.svg": "./src/assets/icons/help/icon8.svg",
	"./help/icon9.svg": "./src/assets/icons/help/icon9.svg",
	"./hide-map-icon.svg": "./src/assets/icons/hide-map-icon.svg",
	"./hiden-password-icon.svg": "./src/assets/icons/hiden-password-icon.svg",
	"./html-icon.svg": "./src/assets/icons/html-icon.svg",
	"./ic_Menu.svg": "./src/assets/icons/ic_Menu.svg",
	"./images-icon.svg": "./src/assets/icons/images-icon.svg",
	"./import-icon.svg": "./src/assets/icons/import-icon.svg",
	"./info-circle-icon.svg": "./src/assets/icons/info-circle-icon.svg",
	"./info-icon.svg": "./src/assets/icons/info-icon.svg",
	"./information-icon.svg": "./src/assets/icons/information-icon.svg",
	"./inventory-black.svg": "./src/assets/icons/inventory-black.svg",
	"./inventory-icon.svg": "./src/assets/icons/inventory-icon.svg",
	"./inventory-light-grey-icon.svg": "./src/assets/icons/inventory-light-grey-icon.svg",
	"./inventory-one-icon.svg": "./src/assets/icons/inventory-one-icon.svg",
	"./inventory.svg": "./src/assets/icons/inventory.svg",
	"./inventoryAsset-icon.svg": "./src/assets/icons/inventoryAsset-icon.svg",
	"./isochrone-icon.svg": "./src/assets/icons/isochrone-icon.svg",
	"./like-dislike-icon.svg": "./src/assets/icons/like-dislike-icon.svg",
	"./link-icon.svg": "./src/assets/icons/link-icon.svg",
	"./list-icon.svg": "./src/assets/icons/list-icon.svg",
	"./location-notification.svg": "./src/assets/icons/location-notification.svg",
	"./log_record.svg": "./src/assets/icons/log_record.svg",
	"./logo-icon.svg": "./src/assets/icons/logo-icon.svg",
	"./logo-login-icon.svg": "./src/assets/icons/logo-login-icon.svg",
	"./logo-login-main.svg": "./src/assets/icons/logo-login-main.svg",
	"./logo-password-icon.svg": "./src/assets/icons/logo-password-icon.svg",
	"./logoNegative-icon.svg": "./src/assets/icons/logoNegative-icon.svg",
	"./manager-icon.svg": "./src/assets/icons/manager-icon.svg",
	"./map_icons/pin-agent-0-tasks-2.png": "./src/assets/icons/map_icons/pin-agent-0-tasks-2.png",
	"./map_icons/pin-agent-0-tasks.png": "./src/assets/icons/map_icons/pin-agent-0-tasks.png",
	"./map_icons/pin-agent-1-tasks-2.png": "./src/assets/icons/map_icons/pin-agent-1-tasks-2.png",
	"./map_icons/pin-agent-1-tasks.png": "./src/assets/icons/map_icons/pin-agent-1-tasks.png",
	"./map_icons/pin-agent-2-tasks-2.png": "./src/assets/icons/map_icons/pin-agent-2-tasks-2.png",
	"./map_icons/pin-agent-2-tasks.png": "./src/assets/icons/map_icons/pin-agent-2-tasks.png",
	"./map_icons/pin-agent-3-tasks-2.png": "./src/assets/icons/map_icons/pin-agent-3-tasks-2.png",
	"./map_icons/pin-agent-3-tasks.png": "./src/assets/icons/map_icons/pin-agent-3-tasks.png",
	"./map_icons/pin-agent-4-tasks-2.png": "./src/assets/icons/map_icons/pin-agent-4-tasks-2.png",
	"./map_icons/pin-agent-4-tasks.png": "./src/assets/icons/map_icons/pin-agent-4-tasks.png",
	"./map_icons/pin-agent-5-tasks-2.png": "./src/assets/icons/map_icons/pin-agent-5-tasks-2.png",
	"./map_icons/pin-agent-5-tasks.png": "./src/assets/icons/map_icons/pin-agent-5-tasks.png",
	"./map_icons/pin-agent-active.gif": "./src/assets/icons/map_icons/pin-agent-active.gif",
	"./map_icons/pin-agent-active.png": "./src/assets/icons/map_icons/pin-agent-active.png",
	"./map_icons/pin-agent-active.svg": "./src/assets/icons/map_icons/pin-agent-active.svg",
	"./map_icons/pin-agent-away-filled.png": "./src/assets/icons/map_icons/pin-agent-away-filled.png",
	"./map_icons/pin-agent-default.png": "./src/assets/icons/map_icons/pin-agent-default.png",
	"./map_icons/pin-agent-inactive-filled.png": "./src/assets/icons/map_icons/pin-agent-inactive-filled.png",
	"./map_icons/pin-agent-inactive.png": "./src/assets/icons/map_icons/pin-agent-inactive.png",
	"./map_icons/pin-agent-multiple-tasks-2.png": "./src/assets/icons/map_icons/pin-agent-multiple-tasks-2.png",
	"./map_icons/pin-agent-multiple-tasks.png": "./src/assets/icons/map_icons/pin-agent-multiple-tasks.png",
	"./map_icons/pin-agent-noData-filled.png": "./src/assets/icons/map_icons/pin-agent-noData-filled.png",
	"./map_icons/pin-agent-offline-filled.png": "./src/assets/icons/map_icons/pin-agent-offline-filled.png",
	"./map_icons/pin-agent-online-filled.png": "./src/assets/icons/map_icons/pin-agent-online-filled.png",
	"./map_icons/pin-emergency.svg": "./src/assets/icons/map_icons/pin-emergency.svg",
	"./map_icons/pin-green.png": "./src/assets/icons/map_icons/pin-green.png",
	"./map_icons/pin-isochronous.png": "./src/assets/icons/map_icons/pin-isochronous.png",
	"./map_icons/pin-pink.png": "./src/assets/icons/map_icons/pin-pink.png",
	"./map_icons/pin-priority-high.svg": "./src/assets/icons/map_icons/pin-priority-high.svg",
	"./map_icons/pin-priority-low.svg": "./src/assets/icons/map_icons/pin-priority-low.svg",
	"./map_icons/pin-priority-medium.svg": "./src/assets/icons/map_icons/pin-priority-medium.svg",
	"./map_icons/pin-task-arrived.svg": "./src/assets/icons/map_icons/pin-task-arrived.svg",
	"./map_icons/pin-task-assigned-partner.svg": "./src/assets/icons/map_icons/pin-task-assigned-partner.svg",
	"./map_icons/pin-task-assigned-team.svg": "./src/assets/icons/map_icons/pin-task-assigned-team.svg",
	"./map_icons/pin-task-auto-assign-failed.svg": "./src/assets/icons/map_icons/pin-task-auto-assign-failed.svg",
	"./map_icons/pin-task-auto-assign-success.svg": "./src/assets/icons/map_icons/pin-task-auto-assign-success.svg",
	"./map_icons/pin-task-auto-assigning.svg": "./src/assets/icons/map_icons/pin-task-auto-assigning.svg",
	"./map_icons/pin-task-cancelled-by-partner.svg": "./src/assets/icons/map_icons/pin-task-cancelled-by-partner.svg",
	"./map_icons/pin-task-cancelled.svg": "./src/assets/icons/map_icons/pin-task-cancelled.svg",
	"./map_icons/pin-task-deleted.svg": "./src/assets/icons/map_icons/pin-task-deleted.svg",
	"./map_icons/pin-task-end-route.png": "./src/assets/icons/map_icons/pin-task-end-route.png",
	"./map_icons/pin-task-executing.svg": "./src/assets/icons/map_icons/pin-task-executing.svg",
	"./map_icons/pin-task-finished.svg": "./src/assets/icons/map_icons/pin-task-finished.svg",
	"./map_icons/pin-task-in-progress.svg": "./src/assets/icons/map_icons/pin-task-in-progress.svg",
	"./map_icons/pin-task-managing.svg": "./src/assets/icons/map_icons/pin-task-managing.svg",
	"./map_icons/pin-task-paused.svg": "./src/assets/icons/map_icons/pin-task-paused.svg",
	"./map_icons/pin-task-start-route.svg": "./src/assets/icons/map_icons/pin-task-start-route.svg",
	"./map_icons/pin-task-waiting-agent.svg": "./src/assets/icons/map_icons/pin-task-waiting-agent.svg",
	"./map_icons/pin-warning.gif": "./src/assets/icons/map_icons/pin-warning.gif",
	"./mark.svg": "./src/assets/icons/mark.svg",
	"./marketplace-icon.svg": "./src/assets/icons/marketplace-icon.svg",
	"./message-icon.svg": "./src/assets/icons/message-icon.svg",
	"./microsoft_logo.svg": "./src/assets/icons/microsoft_logo.svg",
	"./microsoft_logo_text.svg": "./src/assets/icons/microsoft_logo_text.svg",
	"./millenial-theme-icon.svg": "./src/assets/icons/millenial-theme-icon.svg",
	"./miniIcon.svg": "./src/assets/icons/miniIcon.svg",
	"./minilogo-icon.svg": "./src/assets/icons/minilogo-icon.svg",
	"./new-add-icon.svg": "./src/assets/icons/new-add-icon.svg",
	"./new-admin-icon.svg": "./src/assets/icons/new-admin-icon.svg",
	"./new-client-icon.svg": "./src/assets/icons/new-client-icon.svg",
	"./new-region.svg": "./src/assets/icons/new-region.svg",
	"./new.svg": "./src/assets/icons/new.svg",
	"./news-icon.svg": "./src/assets/icons/news-icon.svg",
	"./news-red-icon.svg": "./src/assets/icons/news-red-icon.svg",
	"./newsFunc-icon.svg": "./src/assets/icons/newsFunc-icon.svg",
	"./newsNews-icon.svg": "./src/assets/icons/newsNews-icon.svg",
	"./newsUpdate-icon.svg": "./src/assets/icons/newsUpdate-icon.svg",
	"./non-logo.svg": "./src/assets/icons/non-logo.svg",
	"./non-selected-map-icon.svg": "./src/assets/icons/non-selected-map-icon.svg",
	"./not-satisfactory-icon-png.png": "./src/assets/icons/not-satisfactory-icon-png.png",
	"./notification-icon.svg": "./src/assets/icons/notification-icon.svg",
	"./notification-red-icon.svg": "./src/assets/icons/notification-red-icon.svg",
	"./offline-agent-icon.svg": "./src/assets/icons/offline-agent-icon.svg",
	"./open-accordion-icon.svg": "./src/assets/icons/open-accordion-icon.svg",
	"./operation-icon.svg": "./src/assets/icons/operation-icon.svg",
	"./out-category.svg": "./src/assets/icons/out-category.svg",
	"./parent-task-icon.svg": "./src/assets/icons/parent-task-icon.svg",
	"./partner-icon.svg": "./src/assets/icons/partner-icon.svg",
	"./partner-notification.svg": "./src/assets/icons/partner-notification.svg",
	"./partners-icon.svg": "./src/assets/icons/partners-icon.svg",
	"./pending-icon.svg": "./src/assets/icons/pending-icon.svg",
	"./permissions-light-grey-icon.svg": "./src/assets/icons/permissions-light-grey-icon.svg",
	"./pie-graph-icon-black.svg": "./src/assets/icons/pie-graph-icon-black.svg",
	"./pie-graph-icon.svg": "./src/assets/icons/pie-graph-icon.svg",
	"./planning-icon.svg": "./src/assets/icons/planning-icon.svg",
	"./plus.svg": "./src/assets/icons/plus.svg",
	"./plusb.svg": "./src/assets/icons/plusb.svg",
	"./powered-by-fielder-icon.png": "./src/assets/icons/powered-by-fielder-icon.png",
	"./priority-icon.svg": "./src/assets/icons/priority-icon.svg",
	"./profile-picture-icon.svg": "./src/assets/icons/profile-picture-icon.svg",
	"./recived-invitation-icon.svg": "./src/assets/icons/recived-invitation-icon.svg",
	"./red-add-icon.svg": "./src/assets/icons/red-add-icon.svg",
	"./red-edit-icon.svg": "./src/assets/icons/red-edit-icon.svg",
	"./redAlert-icon.svg": "./src/assets/icons/redAlert-icon.svg",
	"./refresh-icon.svg": "./src/assets/icons/refresh-icon.svg",
	"./refuse-invitation-icon.svg": "./src/assets/icons/refuse-invitation-icon.svg",
	"./reload-forms-icon.svg": "./src/assets/icons/reload-forms-icon.svg",
	"./reload.svg": "./src/assets/icons/reload.svg",
	"./reposition-icon.svg": "./src/assets/icons/reposition-icon.svg",
	"./required.svg": "./src/assets/icons/required.svg",
	"./reschedule-icon.svg": "./src/assets/icons/reschedule-icon.svg",
	"./reset-canceled-tasks-icon.svg": "./src/assets/icons/reset-canceled-tasks-icon.svg",
	"./reset-filter-icon.svg": "./src/assets/icons/reset-filter-icon.svg",
	"./reset-route-tasks-icon.svg": "./src/assets/icons/reset-route-tasks-icon.svg",
	"./restart-route-icon.svg": "./src/assets/icons/restart-route-icon.svg",
	"./review-task-icon.svg": "./src/assets/icons/review-task-icon.svg",
	"./right-arrow-icon.svg": "./src/assets/icons/right-arrow-icon.svg",
	"./role-management-icon.svg": "./src/assets/icons/role-management-icon.svg",
	"./route-icon.svg": "./src/assets/icons/route-icon.svg",
	"./route-notification.svg": "./src/assets/icons/route-notification.svg",
	"./route-preferences.svg": "./src/assets/icons/route-preferences.svg",
	"./satisfactory-icon-png.png": "./src/assets/icons/satisfactory-icon-png.png",
	"./schedule-notification.svg": "./src/assets/icons/schedule-notification.svg",
	"./search-icon.svg": "./src/assets/icons/search-icon.svg",
	"./search-person-icon.svg": "./src/assets/icons/search-person-icon.svg",
	"./security-announcement-icon.svg": "./src/assets/icons/security-announcement-icon.svg",
	"./send-invitation-icon.svg": "./src/assets/icons/send-invitation-icon.svg",
	"./settings-icon.svg": "./src/assets/icons/settings-icon.svg",
	"./shape.svg": "./src/assets/icons/shape.svg",
	"./share-icon.svg": "./src/assets/icons/share-icon.svg",
	"./share-red-icon.svg": "./src/assets/icons/share-red-icon.svg",
	"./show-password-icon.svg": "./src/assets/icons/show-password-icon.svg",
	"./simple-red-add-icon.svg": "./src/assets/icons/simple-red-add-icon.svg",
	"./skills-icon.svg": "./src/assets/icons/skills-icon.svg",
	"./star.svg": "./src/assets/icons/star.svg",
	"./success-alert-icon.svg": "./src/assets/icons/success-alert-icon.svg",
	"./task-icon.svg": "./src/assets/icons/task-icon.svg",
	"./task-notification.svg": "./src/assets/icons/task-notification.svg",
	"./taskGroup-assets-icon.svg": "./src/assets/icons/taskGroup-assets-icon.svg",
	"./taskGroup-form-icon.svg": "./src/assets/icons/taskGroup-form-icon.svg",
	"./taskGroup-image-icon.svg": "./src/assets/icons/taskGroup-image-icon.svg",
	"./taskGroup-inventory-icon.svg": "./src/assets/icons/taskGroup-inventory-icon.svg",
	"./tasktype-icon.svg": "./src/assets/icons/tasktype-icon.svg",
	"./team-notification.svg": "./src/assets/icons/team-notification.svg",
	"./teams-icon.svg": "./src/assets/icons/teams-icon.svg",
	"./temp-icon.png": "./src/assets/icons/temp-icon.png",
	"./temp-user.svg": "./src/assets/icons/temp-user.svg",
	"./topMenuThumbnailProfile-icon.png": "./src/assets/icons/topMenuThumbnailProfile-icon.png",
	"./topMenuUser-icon.svg": "./src/assets/icons/topMenuUser-icon.svg",
	"./trash.svg": "./src/assets/icons/trash.svg",
	"./undo-icon.svg": "./src/assets/icons/undo-icon.svg",
	"./unlink-icon.svg": "./src/assets/icons/unlink-icon.svg",
	"./unlink-route-icon.svg": "./src/assets/icons/unlink-route-icon.svg",
	"./user-icon.svg": "./src/assets/icons/user-icon.svg",
	"./user-login-section.svg": "./src/assets/icons/user-login-section.svg",
	"./view-map-icon.svg": "./src/assets/icons/view-map-icon.svg",
	"./view-table-icon.svg": "./src/assets/icons/view-table-icon.svg",
	"./view.svg": "./src/assets/icons/view.svg",
	"./visibility-button.svg": "./src/assets/icons/visibility-button.svg",
	"./volume-icon.svg": "./src/assets/icons/volume-icon.svg",
	"./waning-toast-icon.svg": "./src/assets/icons/waning-toast-icon.svg",
	"./way-notification.svg": "./src/assets/icons/way-notification.svg",
	"./without-notification-icon.svg": "./src/assets/icons/without-notification-icon.svg",
	"./xlsx-file-icon.svg": "./src/assets/icons/xlsx-file-icon.svg",
	"./yellow-star-icon.png": "./src/assets/icons/yellow-star-icon.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";